/** COOKIE HELPER FUNCTIONS
 * Gets the value of a cookie with the given name.
 * @param {string} a The name of the cookie to get.
 * @returns {string} The value of the cookie, or "false" if no cookie was found.
 */
export function getCookie(a: string) {
  const b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : 'false';
}
/**
 * Sets a cookie with the given name, value and number of days.
 * @param {string} name The name of the cookie to set.
 * @param {string} value The value of the cookie to set.
 * @param {number} days The number of days before the cookie should expire.
 */
export function setCookie(name: string, value: string, days: number) {
  let expires = '';
  let expiresTs: number | undefined;
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
    expiresTs = date.getTime();
  }
  if ('cookieStore' in window) {
    cookieStore
      .set({
        name,
        value: value || '',
        ...(expiresTs && { expires: expiresTs })
      })
      .catch(err => (window as any).Sentry?.captureException(err));
    return;
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
/**
 * Sets a cookie with the given name, value and date.
 * @param {string} name The name of the cookie to set.
 * @param {string} value The value of the cookie to set.
 * @param {Date} [date] The date when the cookie should expire. If no date is given, the cookie will expire at the end of the current session.
 */
export function setCookieToDate(name: string, value: string, date?: Date) {
  let expires = '';
  const expiresTs = date ? date.getTime() : undefined;
  if (date) {
    expires = '; expires=' + date.toUTCString();
  }
  if ('cookieStore' in window) {
    cookieStore
      .set({
        name,
        value: value || '',
        ...(expiresTs && { expires: expiresTs })
      })
      .catch(err => (window as any).Sentry?.captureException(err));
    return;
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
